import { useState } from "react";

import { Button } from "@blueprintjs/core";
import { toast } from "sonner";

import { Box, Flex } from "@/components/layout/flexbox";
import { ReviewSidebarDocument, useAcceptReviewMutation } from "@/graphql";
import { formatErrors } from "@/utils/array";

interface CoachAcceptButtonsProps {
  id: string;
  large?: boolean;
}

export function CoachAcceptButtons({
  id,
  large = false,
}: CoachAcceptButtonsProps) {
  const [processing, setProcessing] = useState(false);
  const [mutate] = useAcceptReviewMutation({
    refetchQueries: [{ query: ReviewSidebarDocument, variables: { id: id } }],
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      setProcessing(false);
      const errors = data?.acceptReview?.errors;
      if (errors?.length) {
        const errorMessage = formatErrors(errors);
        toast.error(errorMessage);
      }
    },
    onError: () => {
      setProcessing(false);
      toast.error("Something went wrong, please try again soon");
    },
  });

  return (
    <Flex flexWrap="wrap">
      <Box>
        <Button
          intent="primary"
          text="Accept"
          large={large}
          loading={processing}
          disabled={processing}
          onClick={() => {
            setProcessing(true);
            mutate({
              variables: {
                reviewId: id,
                accepted: true,
              },
            });
          }}
        />
      </Box>
      <Box ml={2}>
        <Button
          text="Decline"
          large={large}
          loading={processing}
          disabled={processing}
          onClick={() => {
            setProcessing(true);
            mutate({
              variables: {
                reviewId: id,
                accepted: false,
              },
            });
          }}
        />
      </Box>
    </Flex>
  );
}
